(() => {
  if (!document.body.classList.contains('christmas-template')) return;
  if (document.querySelector('.christmas-snow-effect')) return;

  const snow = document.createElement('div');
  snow.className = 'christmas-snow-effect';
  snow.setAttribute('aria-hidden', 'true');

  const particleCount = window.matchMedia('(max-width: 749px)').matches ? 42 : 72;
  const fragment = document.createDocumentFragment();

  for (let index = 0; index < particleCount; index += 1) {
    const flake = document.createElement('span');
    const size = 1 + Math.random() * 3;
    const duration = 9 + Math.random() * 13;

    flake.className = 'christmas-snowflake';
    flake.style.setProperty('--snow-left', `${Math.random() * 100}%`);
    flake.style.setProperty('--snow-size', `${size.toFixed(1)}px`);
    flake.style.setProperty('--snow-opacity', (0.45 + Math.random() * 0.5).toFixed(2));
    flake.style.setProperty('--snow-duration', `${duration.toFixed(1)}s`);
    flake.style.setProperty('--snow-delay', `${(-Math.random() * duration).toFixed(1)}s`);
    flake.style.setProperty('--snow-drift', `${(-45 + Math.random() * 90).toFixed(0)}px`);
    fragment.appendChild(flake);
  }

  snow.appendChild(fragment);
  document.body.appendChild(snow);
})();
